import { jwtDecode } from 'jwt-decode';

// Define the expected structure of the decoded token payload
export interface DecodedCognitoToken {
  sub: string;
  email: string;
  // Add other claims you might need, like exp, iat, etc.
  [key: string]: any; // Allow for other properties
}

/**
 * Decodes a JWT access token.
 * @param token The JWT string.
 * @returns The decoded token payload, or null if decoding fails.
 */
export const decodeToken = (token: string): DecodedCognitoToken | null => {
  try {
    return jwtDecode<DecodedCognitoToken>(token);
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};
